import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser'
import '../assets/styles/Contact.scss';
import {
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  useTheme
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const Contact = () => {
  const theme = useTheme();
  const form = useRef<HTMLFormElement>(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      setError(true);
      return;
    }

    emailjs.send(
      'service_lj5ou5s',
      'template_otvg12d',
      { name, email, message },
      'Vfw-EMAORQ-qeTCbU'
    ).then(
      () => {
        setSuccess(true);
        setName('');
        setEmail('');
        setMessage('');
      },
      (err) => {
        console.error('Email sending error:', err);
        setError(true);
      }
    );
  };

  return (
    <Box
      id="contact"
      sx={{
        maxWidth: 600,
        mx: 'auto',
        mt: 12,
        px: 2,
        py: 4,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
    <Typography
  variant="h4"
  gutterBottom
  className="contact-title"
  sx={{
    color: theme.palette.mode === 'dark' ? 'white' : 'black'
  }}
>
  Contact Me
</Typography>

      <Box component="form" ref={form} onSubmit={sendEmail}>
        <TextField
          label="Name"
          variant="outlined"
          fullWidth
          required
          margin="normal"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          label="Email or Phone"
          variant="outlined"
          fullWidth
          required
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          required
          multiline
          rows={4}
          margin="normal"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <Button
          type="submit"
          variant="contained"
          endIcon={<SendIcon />}
          sx={{
            mt: 2,
            backgroundColor: theme.palette.mode === 'dark' ? '#5000ca' : 'primary.main',
            color: theme.palette.mode === 'dark' ? '#fff' : '#fff',
            '&:hover': {
              backgroundColor: theme.palette.mode === 'dark' ? '#7a1db0' : 'primary.dark',
            },
          }}
        >
          Send
        </Button>
      </Box>

      {/* Success Snackbar */}
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Message sent successfully!
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar open={error} autoHideDuration={3000} onClose={() => setError(false)}>
        <Alert onClose={() => setError(false)} severity="error" sx={{ width: '100%' }}>
          Failed to send message. Please check all fields.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Contact;
